/* I&C · motion layer · Collections index (rd-collections.liquid)
   Rows slide in from the left with a stagger while their hairlines grow; product counts count up (tabular, 1.2 s, ease-out)
   the first time a row is seen; hover gives the big title a gold glow and flips the number once (CSS); the floating plate
   tilts and parallaxes with the cursor; the houses line reveals word by word with its gold dots lighting up in sequence.
   Single IIFE, no globals. Does nothing under prefers-reduced-motion. Phone: stagger slide + count-up only. */
(function () {
  'use strict';
  var MQ_REDUCE = '(prefers-reduced-motion: reduce)';
  var MQ_PHONE = '(max-width: 760px)';
  var MQ_PLATE = '(hover: hover) and (pointer: fine) and (min-width: 1101px)';
  var STAGGER = 130, STAGGER_PHONE = 110, COUNT_MS = 1200, COUNT_LAG = 260;
  var TILT_X = 7, TILT_Y = 10, PAR_X = 16, PAR_Y = 12;

  function init() {
    var section = document.querySelector('.rd .collections');
    if (!section || section.hasAttribute('data-rd-m-collections')) return;
    if (!window.matchMedia || window.matchMedia(MQ_REDUCE).matches) return;
    var list = section.querySelector('.collections__list');
    if (!list) return;
    section.setAttribute('data-rd-m-collections', '');

    var phone = window.matchMedia(MQ_PHONE).matches;
    var rows = Array.prototype.slice.call(list.querySelectorAll('li'));
    var houses = section.querySelector('.houses');
    var plate = section.querySelector('.collections__plate');
    var counters = [];
    var countLoop = 0, lastIn = -1e9;

    /* ---- prepare rows: count-up spans + glow copies of the titles (idempotent, guarded by the section attribute) ---- */
    rows.forEach(function (li, i) {
      li.setAttribute('data-rd-i', i);
      var a = li.querySelector('a');
      if (!a) return;
      var title = a.querySelector('.collections__title');
      if (title && !title.querySelector('.rd-m-collections__glow')) {
        var glow = document.createElement('span');
        glow.className = 'rd-m-collections__glow';
        glow.setAttribute('aria-hidden', 'true');
        glow.innerHTML = title.innerHTML;
        title.appendChild(glow);
      }
      var count = a.querySelector('.collections__count');
      if (count) prepCount(count, li);
    });

    function prepCount(count, li) {
      var nodes = count.childNodes, node = null, m = null;
      for (var k = 0; k < nodes.length; k++) {
        if (nodes[k].nodeType === 3 && /\d/.test(nodes[k].data)) {
          m = /^(\s*)(\d[\d,.   ]*\d|\d)([\s\S]*)$/.exec(nodes[k].data);
          if (m) { node = nodes[k]; break; }
        }
      }
      if (!node) return;
      var raw = m[2];
      var target = parseInt(raw.replace(/\D/g, ''), 10);
      if (!isFinite(target) || target <= 0) return;
      var sep = raw.replace(/\d/g, '').charAt(0);
      /* .collections__count is a flex row (gap 14px): number + unit stay one flex item inside a wrapper */
      var wrap = document.createElement('span');
      wrap.className = 'rd-m-collections__c';
      var span = document.createElement('span');
      span.className = 'rd-m-collections__n';
      span.setAttribute('data-rd-target', raw);
      span.textContent = raw;
      var parent = node.parentNode;
      parent.insertBefore(document.createTextNode(m[1]), node);
      parent.insertBefore(wrap, node);
      wrap.appendChild(span);
      wrap.appendChild(node);
      node.data = m[3];
      counters.push({ li: li, el: span, target: target, sep: sep, raw: raw, start: 0 });
    }

    /* the slot keeps the width of the final string (measured once, again when web fonts land) so the unit never shifts */
    function sizeSlots() {
      var w = counters.map(function (c) { c.el.style.minWidth = ''; return c.el.getBoundingClientRect().width; });
      counters.forEach(function (c, i) { c.el.style.minWidth = Math.ceil(w[i]) + 'px'; });
    }
    if (counters.length) {
      sizeSlots();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (document.fonts.status === 'loaded') sizeSlots(); });
    }

    function fmt(n, sep) {
      var s = String(n);
      if (!sep) return s;
      var out = '';
      while (s.length > 3) { out = sep + s.slice(-3) + out; s = s.slice(0, -3); }
      return s + out;
    }

    function startCount(li, delay) {
      counters.forEach(function (c) {
        if (c.li !== li || c.start) return;
        c.start = performance.now() + delay;
        c.el.textContent = '0';
        if (!countLoop) countLoop = requestAnimationFrame(tick);
      });
    }

    function tick(now) {
      var live = false;
      counters.forEach(function (c) {
        if (!c.start || c.done) return;
        var t = (now - c.start) / COUNT_MS;
        if (t < 0) { live = true; return; }
        if (t >= 1) { c.el.textContent = c.raw; c.done = true; return; }
        var e = 1 - Math.pow(1 - t, 3);
        c.el.textContent = fmt(Math.round(c.target * e), c.sep);
        live = true;
      });
      countLoop = live ? requestAnimationFrame(tick) : 0;
    }

    /* ---- houses: split each name into words, number them for the CSS stagger ---- */
    if (houses && !phone) {
      Array.prototype.slice.call(houses.querySelectorAll('ul > li')).forEach(function (li, i) {
        var a = li.querySelector('a');
        li.style.setProperty('--i', i);
        if (!a || a.querySelector('.rd-m-collections__hw')) return;
        var words = a.children.length ? [a.innerHTML] : a.textContent.trim().split(/\s+/);
        var html = '';
        words.forEach(function (w, j) {
          html += (j ? ' ' : '') + '<span class="rd-m-collections__hw" style="--j:' + j + '">' + (a.children.length ? w : esc(w)) + '</span>';
        });
        a.innerHTML = html;
      });
    }

    function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

    /* ---- arm: pre-states only apply from here on ---- */
    section.classList.add('rd-m-collections');
    if (!phone) section.classList.add('rd-m-collections--full');

    /* ---- entrances: rows keep at least one stagger step between starts, however they arrive.
            A row is revealed when it intersects, or when anything below it does (a fast scroll or an anchor jump can
            skip a row without it ever intersecting), or when the whole list has already left through the top. ---- */
    var pending = rows.slice();
    function revealUpTo(upTo) {
      var batch = [], rest = [];
      pending.forEach(function (li) { (+li.getAttribute('data-rd-i') <= upTo ? batch : rest).push(li); });
      pending = rest;
      if (!batch.length) return;
      var step = phone ? STAGGER_PHONE : STAGGER, now = performance.now();
      batch.forEach(function (li) {
        var d = Math.round(Math.max(0, lastIn + step - now));
        lastIn = now + d;
        li.style.setProperty('--rd-d', d + 'ms');
        li.classList.add('rd-m-in');
        if (io) io.unobserve(li);
        startCount(li, d + COUNT_LAG);
      });
    }
    var io = null;
    if (!('IntersectionObserver' in window)) {
      list.classList.add('rd-m-in');
      if (houses) houses.classList.add('rd-m-in');
      revealUpTo(rows.length);
    } else {
      io = new IntersectionObserver(function (entries) {
        var upTo = -1;
        entries.forEach(function (en) {
          var t = en.target;
          if (t === list) {
            if (en.isIntersecting) list.classList.add('rd-m-in');
            else if (en.boundingClientRect.bottom < (en.rootBounds ? en.rootBounds.top : 0)) upTo = rows.length; /* list already scrolled past */
            if (list.classList.contains('rd-m-in') && !pending.length) io.unobserve(list);
            return;
          }
          if (!en.isIntersecting) return;
          if (t === houses) { houses.classList.add('rd-m-in'); io.unobserve(houses); upTo = rows.length; return; }
          upTo = Math.max(upTo, +t.getAttribute('data-rd-i'));
        });
        if (upTo >= 0) revealUpTo(upTo);
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      io.observe(list);
      rows.forEach(function (li) { io.observe(li); });
      if (houses && !phone) io.observe(houses);
    }

    /* ---- plate: tilt + parallax follows the cursor over the list (desktop, fine pointer, plate visible) ---- */
    if (plate && window.matchMedia(MQ_PLATE).matches) {
      var rect = null, px = 0, py = 0, raf = 0, dirty = true;
      var invalidate = function () { dirty = true; };
      var frame = function () {
        raf = 0;
        if (dirty) { rect = list.getBoundingClientRect(); dirty = false; }
        var nx = Math.max(-0.5, Math.min(0.5, (px - rect.left) / rect.width - 0.5));
        var ny = Math.max(-0.5, Math.min(0.5, (py - rect.top) / rect.height - 0.5));
        plate.style.setProperty('--rd-ry', (nx * TILT_Y).toFixed(2) + 'deg');
        plate.style.setProperty('--rd-rx', (-ny * TILT_X).toFixed(2) + 'deg');
        plate.style.setProperty('--rd-px', (nx * PAR_X).toFixed(1) + 'px');
        plate.style.setProperty('--rd-py', (ny * PAR_Y).toFixed(1) + 'px');
      };
      list.addEventListener('pointerenter', invalidate, { passive: true });
      list.addEventListener('pointermove', function (e) {
        px = e.clientX; py = e.clientY;
        if (!raf) raf = requestAnimationFrame(frame);
      }, { passive: true });
      list.addEventListener('pointerleave', function () {
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
        ['--rd-rx', '--rd-ry', '--rd-px', '--rd-py'].forEach(function (p) { plate.style.removeProperty(p); });
      }, { passive: true });
      window.addEventListener('resize', invalidate, { passive: true });
      window.addEventListener('scroll', invalidate, { passive: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
